import topbar from 'topbar';

export { topbar };

const defaults = { barColors: { 0: '#29d' }, shadowColor: 'rgba(0, 0, 0, .3)' };

export const initTopBar = (): void => topbar.config(defaults);
export const showTopBar = (): void => topbar.show();
export const hideTopBar = (): void => topbar.hide();


